module.exports = __webpack_public_path__ + "static/media/laravel.8bfc5015.png";